import React from "react";
import Title from "../../components/titles/Title";

// ComingSoon component for displaying a "Coming Soon" section
const ComingSoon = () => {
  return (
    // Main container for the section
    <div className="section-container benefit-container">
      <div className="container">
        <div className="section-sub-container">
          {/* Title component with centered text and some margin and padding */}
          <Title classname="text-center mb-4 p-5" heading="Coming Soon" />
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
